import { ReactComponent as Logo } from './Images/logo.svg';
import { ReactComponent as SmallLogo } from './Images/logo_small.svg';

import { isMobile } from 'react-device-detect';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import React, { Fragment, useEffect } from 'react';
import { Redirect, Switch, Route, useParams, useLocation } from 'react-router-dom';

import CookieConsent from 'react-cookie-consent';

import { AppBar, IconButton, Typography, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';
import DialogWithEnterAction from './components/DialogWithEnterAction';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import { CompareGCFirmwares, CompareWifiFirmwares } from './Utils/firmware_utils.js';
import { installBrowserConnectionLifecycle } from './Utils/browser_connection_lifecycle.js';
import { ControllerForAlarm } from './Utils/alarm_utils.js';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';

import i18next from 'i18next';

import { Helmet } from 'react-helmet';

import MainMenu from './Menus/MainMenu';
import UserMenu from './Menus/UserMenu';
import { CheckForControllerExists } from './Pages/ControllerPage';
import ManagePage from './Pages/ManagePage';
import AccountPage from './Pages/Account';
import LoginPage from './Pages/LoginPage';
import ResetPage from './Pages/ResetPage';
import UserManagePage from './Pages/UserManagePage';
import RegistrationPage from './Pages/RegistrationPage.js';
import SetupPage from './Pages/SetupPage';
import { useAuth } from './Hooks/authHook';
import { useAddress } from './Hooks/addressHook';
import { AddInfo } from './Contents/AddInfo';
import { TabInfo } from './Contents/TabInfo';
import AlarmModal from './Contents/Alarms';
import MessagesModal from './Contents/Messages';
import { Error404 } from './components/Error404';
import { ControllerIdentity } from './components/ControllerIdentity';
import FirmwareRecoveryButton from './FormWidgets/FirmwareRecoveryButton';
import ManualFirmwareUpdate from './components/DeveloperTools/ManualFirmwareUpdate';

import { statusColors } from './Constants/constants';

import { LockSliderContext } from './Contexts';

import { AlarmSelect, GenericSelect } from './FormWidgets/Select';
import Description from './FormWidgets/Description';
import { ShowNotificationBanner } from './FormWidgets/NotificationBanner.js';
import { useSnackbar } from 'notistack';

import getStateManager from './StateManager.js';
import { useSnapshot, proxy } from 'valtio';
import { useTransition } from 'react';

const emptyInfosProxy = proxy({});

// usefull for debugging
console.dump = (v) => console.log(Object.keys({ v })[0], v);

const routes = [
  {
    path: '/',
    exact: true,
    title: 'manage_controllers',
    main: ({ user }) => <ManagePage user={user} />,
    private: true
  },
  {
    path: '/controller/:id',
    title: () => <ControllerName />,
    main: () => <CheckForControllerExists />,
    condition: (stateManager) => {
      return stateManager.controllers.length > 0;
    },
    private: true
  },
  {
    path: '/account',
    title: 'account_settings',
    main: ({ user, setUser }) => <AccountPage user={user} setUser={setUser} />,
    private: true
  },
  {
    path: '/users',
    title: 'user_management',
    main: ({ user, setUser }) => <UserManagePage user={user} setUser={setUser} />,
    private: true
  },
  {
    path: '/login',
    title: 'login',
    main: () => <LoginPage />,
    private: false
  },
  {
    path: '/register',
    title: 'register',
    main: () => <RegistrationPage />,
    private: false
  },
  {
    path: '/reset',
    title: 'password_reset',
    main: () => <ResetPage />,
    private: false
  },
  {
    path: '/setup',
    title: 'mode_setup',
    main: () => <SetupPage />,
    private: false
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  title: {
    gridColumn: 2,
    justifySelf: 'center',
    maxWidth: '40vw',
    minWidth: 0,
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    zIndex: 2
  },
  black: {
    backgroundColor: theme.palette.appbar_bg
  },
  compact_toolbar: {
    minHeight: 56,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  mobile_menu_icon: {
    fontSize: 26
  },
  mobile_logo: {
    flexShrink: 0,
    height: 18,
    width: 'auto'
  },
  add_info: {
    color: theme.palette.primary.main,
    fontSize: '1.1em',
    fontWeight: 500,
    gridColumn: 3,
    justifySelf: 'end',
    marginRight: 30,
    maxWidth: 'calc(100% - 30px)',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  tab_info: {
    color: theme.palette.primary.main,
    fontSize: '1.1em',
    fontWeight: 500,
    gridColumn: 1,
    justifySelf: 'start',
    marginLeft: 30,
    maxWidth: 'calc(100% - 30px)',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  info_container: {
    alignItems: 'center',
    display: 'grid',
    flexGrow: 1,
    gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)'
  },
  compact_toolbar_mobile: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    marginTop: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: '100%'
  },
  title_mobile: {
    alignSelf: 'center',
    lineHeight: 1.1,
    maxWidth: '100%',
    paddingBottom: theme.spacing(0.5),
    paddingTop: 0,
    width: '100%'
  },
  mobile_info_row: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 24,
    width: '100%'
  },
  tab_info_mobile: {
    color: theme.palette.primary.main,
    fontSize: '1.0em',
    fontWeight: 500
  },
  add_info_mobile: {
    color: theme.palette.primary.main,
    fontSize: '1.0em',
    fontWeight: 500
  },
  appbarSpacer: theme.mixins.toolbar,

  mobileAppbarSpacer: {
    height: 84
  },
  mobileControllerAppbarSpacer: {
    height: 108
  }
}));

export function App({ currTheme, toggleTheme }) {
  let { t } = useTranslation();
  const address = useAddress();
  const auth = useAuth();
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm')) || isMobile;

  // User
  const [user, setUser] = React.useState({});

  // Snackbar
  const [open, setOpen] = React.useState(false);
  const { messageInfo, setMessageInfo } = React.useState(undefined);
  const handleExited = () => {
    setMessageInfo(undefined);
  };
  let { enqueueSnackbar } = useSnackbar();

  // language
  const [lang, setLang] = React.useState('de');

  // Close dialogs
  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  // Genral state.
  const [state, setState] = React.useState({
    showMainMenu: false,
    showUserMenu: false,
    userMenuAnchor: null
  });

  // ----- set-up global connection. ----- //

  const [no_connection, setNoConnection] = React.useState(false);

  // stateManager, everything in here is controller related (for now)
  const stateManager = getStateManager();
  const wsManager = stateManager.wsManager;
  const authenticatedUser = auth.user;
  const validateSession = auth.validateSession;

  useEffect(() => {
    return installBrowserConnectionLifecycle({
      getWsManager: () => stateManager.wsManager,
      getSimulation: () => stateManager.simulation,
      authenticatedUser,
      validateSession,
      retryInitialization: () => {
        if (!stateManager.controllers_loaded) stateManager.refreshControllerMetadata();
        if (process.env.REACT_APP_SKIP_LOGIN !== 'true')
          stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
      }
    });
  }, [authenticatedUser, validateSession, stateManager, wsManager]);

  React.useEffect(() => {
    if (auth.user) {
      // wasm.then((wasm) => {
      // pass non-valtio native react hooks
      stateManager.init(undefined, address, {
        enqueueSnackbar: enqueueSnackbar,
        setNoConnection: setNoConnection,
        t: t,
        onAuthenticationFailed: auth.invalidateSession,
        validateSession: auth.validateSession,
        onControllerDataLoaded: process.env.REACT_APP_SKIP_LOGIN === 'true' ? undefined : (json) => {
          json.controller.forEach((c) => stateManager.addController(
            c, auth.user,
            json.access_rights?.per_controller ?? (c.api_version <= 'ADED' ? 'all' : 'none')
          ));
          const account_language = json.language;
          setLang(account_language);
          setUser({
            name: auth.user,
            email: json.email,
            language: account_language,
            admin: json.admin,
            sub_users: json.admin ? json.sub_users : {},
            access_rights: json.access_rights,
            _2fa_enabled: json._2fa_enabled,
            messages: json.messages
          });
          stateManager.alarms.activeAlarms = json.alarms.map((alarm) => ({
            ...alarm, controller: ControllerForAlarm(stateManager.controllers, alarm)
          }));
          stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
        }
      });

      if (process.env.REACT_APP_SKIP_LOGIN !== 'true') {
        stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
      }

      if (process.env.REACT_APP_SKIP_LOGIN === 'true') {
        stateManager.addController(
          {
            internal_id: 'local',
            id: 'local',
            name: 'local',
            simulation: false,
            mac_adress: '1-1-1-1',
            type: 6000
          },
          auth.user,
          'all'
        );
        setLang('de');
        setUser({ name: auth.user, email: 'local@mail.de', language: 'de' });
        stateManager.controllers_loaded = true;
      } else {
        stateManager.refreshControllerMetadata();
      }
      // });
    }
    return () => {
      stateManager.cancelControllerMetadataRefresh();
      stateManager.wsManager?.suspend?.('session-cleanup');
      stateManager.simulation?.stop?.();
    };
  }, [auth.invalidateSession, auth.user, auth.validateSession]);

  // Set language
  useEffect(() => {
    // If no local language is set, update local language to account-language.
    const account_language = user.language;
    let session_language = localStorage.getItem('i18nextLng') || account_language || 'de';
    if (session_language === 'undefined' || session_language === 'null')
      session_language = account_language;
    // Update local-storage and current session-language with the set language.
    i18next.changeLanguage(session_language);
    setLang(session_language);
  }, [user]);

  const toggleMainMenu = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setState((prev) => ({ ...prev, showMainMenu: open }));
  };

  const toggleUserMenu = (open) => (event) => {
    event.stopPropagation();
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setState((prev) => ({
      ...prev,
      showUserMenu: open,
      userMenuAnchor: open ? event.currentTarget : null
    }));
  };

  const closeNavigationMenus = () => {
    setState((prev) => ({
      ...prev,
      showMainMenu: false,
      showUserMenu: false,
      userMenuAnchor: null
    }));
  };

  const closeNoConnectionInfoDialog = () => {
    setOpen(false);
  };

  const [open_developer_tools, setOpenDeveloperTools] = React.useState(false);
  const closeDeveloperOptions = () => {
    setOpenDeveloperTools(false);
  };
  const openDeveleloperOptions = React.useCallback((event) => {
    if (
      event.key === 'F4' &&
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !event.repeat
    ) {
      event.preventDefault();
      setOpenDeveloperTools(true);
    }
  }, []);
  useEffect(() => {
    document.addEventListener('keydown', openDeveleloperOptions, false);
    return () => {
      document.removeEventListener('keydown', openDeveleloperOptions, false);
    };
  }, []);

  const [lockSliderSetting, setLockSliderSetting] = React.useState(
    localStorage.getItem('lockSliderSetting') || 'auto'
  );
  useEffect(() => {
    localStorage.setItem('lockSliderSetting', lockSliderSetting);
  }, [lockSliderSetting]);

  const location = useLocation();
  const controllerIdRegex = /^\/controller\/([^/]+)/;
  const tabIdRegex = /^\/controller\/[^/]+\/zones\/[^/]+\/([^/]+)/;
  const tabIdWithoutZoneRegex = /^\/controller\/[^/]+\/([^/]+)$/;
  const zoneIdRegex = /^\/controller\/[^/]+\/zones\/([^/]+)/;

  const controllerSelected = controllerIdRegex.test(location.pathname);

  // Subscribe to controller changes for reactivity
  useSnapshot(stateManager.controllers);

  // Get controller id from route if available
  let controller;
  let tab_id;
  let zone_id;

  if (controllerSelected) {
    const match = location.pathname.match(controllerIdRegex);
    if (match) {
      const controllerId = match[1];
      controller = stateManager.getControllerById(controllerId);
    }

    // Try zone-based pattern first
    const tabMatchWithZone = location.pathname.match(tabIdRegex);
    if (tabMatchWithZone) {
      tab_id = tabMatchWithZone[1];
    } else {
      // Try non-zone-based pattern next
      const tabMatchWithoutZone = location.pathname.match(tabIdWithoutZoneRegex);
      if (tabMatchWithoutZone) {
        tab_id = tabMatchWithoutZone[1];
      }
    }

    const zoneMatch = location.pathname.match(zoneIdRegex);
    if (zoneMatch) {
      zone_id = zoneMatch[1];
    }
  }

  // Get parent with zone_id support
  let parentInfosProxy = emptyInfosProxy;
  if (controller) {
    const parent = stateManager.getParent(controller, zone_id);
    // Only use parent.infos if it exists and is a valid proxy
    if (parent && parent.infos && typeof parent.infos === 'object') {
      parentInfosProxy = parent.infos;
    }
  }
  const parentInfos = useSnapshot(parentInfosProxy);

  const [firmware_versions, setFirmwareVersions] = React.useState({
    5053: [],
    5052: [],
    5055: [],
    5155: [],
    6000: []
  });

  useEffect(() => {
    const request = new AbortController();
    if (auth.user) {
      fetch(address.api_url('/api/versions'), { signal: request.signal })
        .then(async (response) => {
          if (!response.ok) return;
          const data = await response.json();
          if (!request.signal.aborted && stateManager.store() === stateManager)
            setFirmwareVersions({ ...data.version_numbers });
        })
        .catch((error) => {
          if (!request.signal.aborted && stateManager.store() === stateManager)
            console.warn('[firmware-versions] request failed', error);
        });
    }
    return () => request.abort();
  }, [auth.user, controller?.connection?.status]);

  const classes = useStyles();
  // const isXS = useMediaQuery((theme) => theme.breakpoints.down('sm')); TODO (fux): is this needed?
  return (
    <Fragment>
      <Helmet htmlAttributes={{ lang: lang }}>
        <meta http-equiv="content-language" content={lang} />
      </Helmet>

      {/* End Normal firmware update */}
      <>
        <AppBar className={classes.black} position="fixed" color="secondary">
          <Toolbar {...(mobile && { className: classes.compact_toolbar })}>
            <IconButton edge="start" onClick={toggleMainMenu(true)} color="inherit" aria-label="menu">
              <MenuIcon className={mobile ? classes.mobile_menu_icon : undefined} />
            </IconButton>
            <Fragment>
              {mobile ? (
                <SmallLogo className={classes.mobile_logo} fill="#ffffff" />
              ) : (
                <Logo height={16} fill="#ffffff" />
              )}
              <div className={classes.info_container}>
                {!mobile && (
                  <TabInfo
                    className={classes.tab_info}
                    zone_id={zone_id}
                    tab_id={tab_id}
                    controller={controller}
                  />
                )}
                {!mobile && <PageTitle stateManager={stateManager} />}
                {!mobile && (
                  <AddInfo
                    className={classes.add_info}
                    time={parentInfos.time}
                    phase={parentInfos.phase}
                  />
                )}
              </div>
              <MessagesModal logged_in={auth.user !== null} />
              <AlarmModal logged_in={auth.user !== null} />
            </Fragment>
          </Toolbar>
          {mobile && (
            <Toolbar className={classes.compact_toolbar_mobile}>
              <PageTitle stateManager={stateManager} mobile />
              {controllerSelected && (
                <div className={classes.mobile_info_row}>
                  <TabInfo
                    className={classes.tab_info_mobile}
                    zone_id={zone_id}
                    tab_id={tab_id}
                    controller={controller}
                  />
                  <AddInfo
                    className={classes.add_info_mobile}
                    time={parentInfos.time}
                    phase={parentInfos.phase}
                  />
                </div>
              )}
            </Toolbar>
          )}
        </AppBar>
        <div
          className={
            mobile
              ? controllerSelected
                ? classes.mobileControllerAppbarSpacer
                : classes.mobileAppbarSpacer
              : classes.appbarSpacer
          }
        />
        {auth.user &&
          user.messages !== undefined &&
          Object.entries(user.messages).map(
            ([message, show]) =>
              show &&
              message !== 'message_telegram_group' && (
                <ShowNotificationBanner key={message} message={t(message)} user={user} />
              )
          )}
        {/* Recovery firmware update */}
        {/* End Recovery firmware update */}
        {/* Normal firmware update */}
        {/* Main controller */}
        {auth.user &&
          controllerSelected &&
          controller?.type !== undefined &&
          [5055, 5053, 5052].includes(controller?.type) &&
          controller?.connection?.status !== undefined &&
          controller?.connection?.status === 'good' &&
          controller?.simulation !== undefined &&
          !controller?.simulation &&
          CompareGCFirmwares(controller, firmware_versions) && (
            <ShowNotificationBanner
              message={t('gc_firmware_update_notification_bar_text')}
              to={`/controller/${controller.id}/system#firmware`}
            />
          )}
        {/* Wi-Fi module */}
        {auth.user &&
          controllerSelected &&
          controller?.type !== undefined &&
          [5055, 5053, 5052].includes(controller?.type) &&
          controller?.connection?.status !== undefined &&
          controller?.connection?.status === 'good' &&
          controller?.simulation !== undefined &&
          !controller?.simulation &&
          CompareWifiFirmwares(controller, firmware_versions) && (
            <ShowNotificationBanner
              message={t('wifi_firmware_update_notification_bar_text')}
              to={`/controller/${controller.id}/system#firmware`}
            />
          )}
      </>
      <NoConnectionInfoDialog open={no_connection} handleClose={closeNoConnectionInfoDialog} />
      <DeveloperTools
        open={open_developer_tools}
        handleClose={closeDeveloperOptions}
        controller={auth.user ? controller : undefined}
      />
      <MainMenu
        open={state.showMainMenu}
        onClose={toggleMainMenu(false)}
        currTheme={currTheme}
        toggleTheme={toggleTheme}
        toggleUserMenu={toggleUserMenu}
        onNavigate={closeNavigationMenus}
        setLang={setLang}
        lockSliderSetting={lockSliderSetting}
        setLockSliderSetting={setLockSliderSetting}
      />
      <UserMenu
        open={state.showUserMenu}
        onClose={toggleUserMenu(false)}
        onNavigate={closeNavigationMenus}
        anchor={state.userMenuAnchor}
        user={user}
      />
      <LockSliderContext.Provider value={lockSliderSetting}>
        <MainContent
          stateManager={stateManager}
          user={user}
          setUser={setUser}
          wsManager={wsManager}
        />
      </LockSliderContext.Provider>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
        action={
          <React.Fragment>
            <IconButton aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleClose} severity={messageInfo ? messageInfo.type : undefined}>
          {messageInfo ? messageInfo.message : undefined}
        </Alert>
      </Snackbar>
      <CookieConsent
        buttonText={t('cookie_consent_button')}
        buttonStyle={{ backgroundColor: statusColors.good, color: '#000000', fontWeight: 700 }}
      >
        {t('cookie_consent')}
      </CookieConsent>
      <div style={{ display: 'flex', justifyContent: 'right', margin: '20px' }}>
        <Description id="pre_release_notice" />
      </div>
    </Fragment>
  );
}

function NoConnectionInfoDialog({ open, handleClose }) {
  let { t } = useTranslation();
  const style = {
    marginBottom: 20
  };
  const refresh = () => {
    window.location.reload();
  };
  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={refresh}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{t('no_server_connection_msg_title')}</DialogTitle>
      <DialogContent style={style}>{t('no_server_connection_msg_body')}</DialogContent>
      <DialogActions>
        <Button onClick={refresh} color="primary">
          {t('refresh')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ControllerName({ ...props }) {
  let { id } = useParams();
  const stateManager = getStateManager();

  const controller = stateManager.getControllerById(id);

  return <ControllerIdentity controller={controller} />;
}

function PageTitle({ stateManager, mobile = false, ...props }) {
  let { t } = useTranslation();
  const classes = useStyles();

  let controllers = useSnapshot(stateManager.controllers);

  return (
    <Switch>
      {routes.map(
        (route, index) =>
          (route.condition !== undefined ? route.condition(stateManager) : true) && (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              children={
                <Typography
                  className={`${classes.title}${mobile ? ` ${classes.title_mobile}` : ''}`}
                  variant="h6"
                >
                  {typeof route.title === 'function' ? (
                    <route.title controllers={controllers} />
                  ) : (
                    t(route.title)
                  )}
                </Typography>
              }
            />
          )
      )}
    </Switch>
  );
}

function MainContent({ stateManager, user, setUser, ...other }) {
  const address = useAddress();
  const auth = useAuth();
  return (
    <Switch>
      {routes.map(
        (route, index) =>
          (route.condition !== undefined && auth.user ? route.condition(stateManager) : true) && (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              children={({ location }) =>
                !route.private || auth.user ? (
                  <route.main user={user} setUser={setUser} />
                ) : process.env.REACT_APP_STATIC_USING_APP === 'true' && address.api === '' ? (
                  <Redirect to={{ pathname: '/setup', state: { from: location } }} />
                ) : auth.sessionPending ? (
                  <CircularProgress />
                ) : (
                  <Redirect to={{ pathname: '/login', state: { from: location } }} />
                )
              }
            />
          )
      )}
      <Route path="*">
        <Error404 />
      </Route>
    </Switch>
  );
}

function DeveloperTools({ open, handleClose, controller }) {
  const [alarm, setAlarm] = React.useState({ name: 'all', value: 90 });
  const [zone, setZone] = React.useState({ id: 0xff, name: '' });
  const simulation = getStateManager().simulation;
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle id="form-dialog-title">Developer Tools</DialogTitle>
      <DialogContent>
        <FirmwareRecoveryButton controller={controller} onClick={handleClose} />
        <ManualFirmwareUpdate controller={controller} onClose={handleClose} />
        {simulation && (
          <>
            Test alarms:
            <AlarmSelect
              label="alarm-name"
              value={alarm.name}
              onChange={(event) => setAlarm({ ...alarm, name: event.target.value })}
            />
            <TextField
              autoFocus
              margin="dense"
              id="serial"
              label="Value"
              type="number"
              fullWidth
              value={alarm.value}
              onChange={(event) => setAlarm({ ...alarm, value: event.target.value })}
            />
            {simulation.zones.length > 0 && (
              <GenericSelect
                onChange={(evt) => setZone({ id: evt.target.value, name: evt.target.label })}
                values={Object.values(simulation.zones)
                  .map((z) => ({ value: parseInt(z.id), label: z.name }))
                  .concat([
                    { value: 0xfe, label: t('global') },
                    { value: 0xff, label: t('undefined') }
                  ])}
                value={zone}
              />
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {simulation && (
          <>
            <Button
              onClick={(evt) => simulation.send_alarm(evt, zone.id, zone.name, alarm)}
              color="primary"
            >
              Trigger Alarm
            </Button>
            <Button
              onClick={(evt) => simulation.resolve_alarm(evt, zone.id, zone.name, alarm)}
              color="primary"
            >
              Resolve Alarm
            </Button>
          </>
        )}
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
